const success = (app, text, title, duration) => {
  duration = duration || 5000;
  title = title || 'Sucesso!';
  app.$notify({
    group: 'app',
    type: 'success',
    title,
    text,
    duration
  });
  return Promise.resolve(true);
};

const error = (app, text, title, duration) => {
  duration = duration || 5000;
  title = title || 'Ocorreu um erro!';
  app.$notify({
    group: 'app',
    type: 'error',
    title,
    text,
    duration
  });
  return Promise.resolve(true);
};

const warn = (app, text, title, duration) => {
  duration = duration || 5000;
  title = title || 'Atenção!';
  app.$notify({
    group: 'app',
    type: 'warn',
    title,
    text,
    duration
  });
  return Promise.resolve(true);
};

export default {
  success,
  warn,
  error
}



//////////////////
// WEBPACK FOOTER
// ./src/components/shared/notification/notifications
// module id = null
// module chunks = 